import { combineReducers } from 'redux';
import Timetravel from './timetravel';

const rootReducer = combineReducers({
  Timetravel,
});

export default rootReducer;
